import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";

import DinoForm from "./pages/DinoForm";
import DinosList from "./pages/DinosList";
import DinoDetail from "./pages/DinoDetail";

import AdminPaleosList from "./pages/AdminPaleosList";
import AdminPaleosForm from "./pages/AdminPaleosForm";

const App = () => {
  return (
    <>
      <Header />

      <div className="container mt-4">
        <Routes>

          {/* ---------- PÚBLICO ---------- */}
          <Route path="/" element={<Home />} />
          <Route path="/dinos" element={<DinosList />} />
          <Route path="/dinos/:id" element={<DinoDetail />} />

          {/* ---------- AUTENTICACIÓN ---------- */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* ---------- ADMIN DINOSAURIOS ---------- */}
          <Route
            path="/admin/dinos/new"
            element={
              <ProtectedRoute>
                <DinoForm />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/dinos/edit/:id"
            element={
              <ProtectedRoute>
                <DinoForm />
              </ProtectedRoute>
            }
          />

          {/* ---------- ADMIN PALEONTÓLOGOS ---------- */}
          <Route
            path="/admin/paleos"
            element={
              <ProtectedRoute>
                <AdminPaleosList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/paleos/new"
            element={
              <ProtectedRoute>
                <AdminPaleosForm mode="create" />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/paleos/edit/:id"
            element={
              <ProtectedRoute>
                <AdminPaleosForm mode="edit" />
              </ProtectedRoute>
            }
          />

        </Routes>
      </div>
    </>
  );
};



// ---------------- HEADER ----------------

const Header = () => {
  const { token, logout } = useAuth();

  return (
    <nav className="navbar navbar-expand-lg bg-success navbar-dark">
      <div className="container">

        <Link className="navbar-brand" to="/">
          DinoApp 🌋
        </Link>

        {/* BOTÓN MOBILE */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="mainNavbar">

          {/* MENU IZQUIERDA */}
          <ul className="navbar-nav me-auto">

            <li className="nav-item">
              <Link className="nav-link text-white fs-5" to="/dinos">
                Ver Dinosaurios
              </Link>
            </li>

            {token && (
              <>
                <li className="nav-item">
                  <Link
                    className="nav-link text-white fs-5"
                    to="/admin/dinos/new"
                  >
                    Cargar Dino
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link text-white fs-5"
                    to="/admin/paleos"
                  >
                    Paleontólogos
                  </Link>
                </li>
              </>
            )}

          </ul>

          {/* MENU DERECHA */}
          <ul className="navbar-nav ms-auto">

            {!token ? (
              <>
                <li className="nav-item">
                  <Link className="nav-link text-white fs-5" to="/login">
                    Login
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link text-white fs-5" to="/register">
                    Registro
                  </Link>
                </li>
              </>
            ) : (
              <li className="nav-item">
                <button
                  className="btn btn-outline-light btn-lg px-4 py-2"
                  onClick={logout}
                >
                  Logout
                </button>
              </li>
            )}

          </ul>

        </div>
      </div>
    </nav>
  );
};



// ---------------- PROTECTED ROUTE ----------------

const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();

  if (!token) {
    return (
      <div className="alert alert-secondary mt-4 p-5 rounded fs-4 text-center">
         Tienes que iniciar sesión para acceder al BackOffice (admin).
      </div>
    );
  }

  return children;
};

export default App;
